import { facadeFactory } from '@spartacus/core'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { CHECKOUT_CORE_FEATURE } from '@spartacus/checkout/base/root'

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: MbCheckoutShippingFacade,
      feature: CHECKOUT_CORE_FEATURE,
      methods: [
        'openAddNewAddressForm',
        'cancelAddNewAddressForm'
      ],
      properties: [
        'isDisplaySimpleButtons',
        'isAddNewAddressesFormVisible',
      ],
      async: true,
    }),
})
export abstract class MbCheckoutShippingFacade {
  abstract get isDisplaySimpleButtons(): Observable<boolean>
  abstract get isAddNewAddressesFormVisible(): Observable<boolean>

  /**
   * Opens/Shows the add new address form
   */
  abstract openAddNewAddressForm(): void

  /**
   * Closes/Hides the add new address form
   */
  abstract cancelAddNewAddressForm (): void
}
